module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/sale_ic@3x-14bb914217e158db3994ff49d3c136a8.png";